// src/store/modules/store.logs.ts

export interface LogItem {
    log_id: number;
    resource: 'user' | 'customer' | 'pet';
    operation_type: "INSERT" | "UPDATE" | "DELETE";
    changed_at: string;
    last_update: string;
    last_update_user_id: number;
    last_update_user_name: string;
    [key: string]: any; // other fields from logs tables
}

const logsResetState = () => ({
    logs: [] as LogItem[],
});

export const logs = {
    state: logsResetState(),

    getters: {
        getLogs(state: any): LogItem[] {
            return state.logs;
        },
        getLogsCount(state: any): number {
            return state.logs.length;
        },
    },

    mutations: {
        setLogs(state: any, logs: LogItem[])
        {
            console.log("Setting logs...", logs);
            state.logs = logs
        },

        clearLogs(state: any)
        {
            state.logs = [];
        },
    },

    actions: {
        fetchLogs(state: any)
        {
            console.log("Fetching logs...");
            return new Promise((resolve, reject) => {
                fetch(process.env.BASE_URL + `api/logs`,
                    {
                        method: 'GET',
                        headers:
                        {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    })
                    .then(res => res.json())
                    .then(logs => {
                        state.commit('setLogs', logs)
                        resolve(logs)
                    })
                    .catch(err => reject(err))
            })
        },

        clearAllLogs(state: any) {
            state.commit('clearLogs');
        },
    },
};